/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class Attendance {
  baseApi = ENV.BASE_API;

  async createAttendance(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ATTENDANCE}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  //* Se usa
  async createMassiveAttendance(accessToken, gradeId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ATTENDANCE}/daily/grade/${gradeId}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAttendanceByStudent(accessToken, studentId, academicCycleId, params = {}) {
    try {
      const queryParams = new URLSearchParams({
        studentId,
        academicCycleId,
        ...params,
      }).toString();
      
      const url = `${this.baseApi}/${ENV.API_ROUTES.ATTENDANCE}/student?${queryParams}`;
      const requestParams = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, requestParams);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  //* Se usa
  async getAttendanceHistoryByCycle(accessToken, studentId, academicCycleId, params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const queryString = queryParams ? `?${queryParams}` : '';
      
      const url = `${this.baseApi}/${ENV.API_ROUTES.ATTENDANCE}/student/${studentId}/cycle/${academicCycleId}${queryString}`;
      const requestParams = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, requestParams);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAttendanceStatistics(accessToken, studentId, academicCycleId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ATTENDANCE}/student/${studentId}/statistics?academicCycleId=${academicCycleId}`;
      const requestParams = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, requestParams);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAttendanceByGradeAndDate(accessToken, gradeId, academicCycleId, date, params = {}) {
    try {
      const queryParams = new URLSearchParams({
        gradeId,
        academicCycleId,
        date,
        ...params,
      }).toString();
      
      const url = `${this.baseApi}/${ENV.API_ROUTES.ATTENDANCE}/grade?${queryParams}`;
      const requestParams = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, requestParams);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  //* Se usa para cargar asistencia diaria existente
  async getDailyAttendanceByGradeAndDate(accessToken, gradeId, date, academicCycleId) {
    try {
      const queryParams = new URLSearchParams({
        date,
        academicCycleId,
      }).toString();
      
      const url = `${this.baseApi}/${ENV.API_ROUTES.ATTENDANCE}/daily/grade/${gradeId}?${queryParams}`;
      const requestParams = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, requestParams);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateAttendance(accessToken, attendanceId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ATTENDANCE}/${attendanceId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteAttendance(accessToken, attendanceId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ATTENDANCE}/${attendanceId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}